import React, { useState, useContext, useEffect } from "react";
import DynamicIcon from "../../components/dynamicicon";
import JisButton from "../../components/controls/jisButton";
import JisCheckbox from "../../components/controls/jisCheckbox";
import { ShareContext } from "../../context/ShareContext";
import * as Constants from "../../constants";
import * as Services from "../../services";
import JisTabButton from "../../components/controls/jisTabButton";
import BackLoader from "../../components/backloader";
import JisDialog from "../../components/dialog";
import JisDialogForm from "../../components/formdialog";

function CourtSettings() {
  const { activePage, token, setIsExpired, setAlert, frequentData } =
    useContext(ShareContext);
  const [page, setPage] = useState(null);
  const [tab, setTab] = useState("courts");
  const [court, setCourt] = useState({ id: 0 });
  const [courtType, setCourtType] = useState({ id: 0 });
  const [courts, setCourts] = useState([]);
  const [courtTypes, setCourtTypes] = useState([]);
  const [rooms, setRooms] = useState([]);
  const [room, setRoom] = useState({ id: 0 });
  const [isDialog, setIsDialog] = useState(false);
  const [divisions, setDivisions] = useState([]);
  const [judgeTypes, setJudgeTypes] = useState([]);

  const [err, setErr] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    onLoadCourt();
    onLoadCourtType();
    onLoadJudgeTypes();
    onLoadDivisions();
  }, []);
  const onCourtChange = (e) => {
    setCourt({ ...court, [e.target.name]: e.target.value });
  };
  const onCourtTypeChange = (e) => {
    setCourtType({ ...courtType, [e.target.name]: e.target.value });
  };
  const onRoomChange = (e) => {
    setRoom({ ...room, [e.target.name]: e.target.value });
  };

  const onAdd = () => {
    setIsDialog(true);
  };
  const onClose = () => {
    setIsDialog(false);
    setCourt({ id: 0 });
    setCourtType({ id: 0 });
  };
  const onLoadDivisions = async () => {
    //for account registration
    try {
      setLoading(true);
      const resp = await fetch(
        `${Constants.apiUrl}/setup/location-setting/divisions`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );

      const data = await resp.json();
      setDivisions(data.list);
    } catch (error) {
      setLoading(false);
      console.error(error);
    }
  };
  const onSave = async (e) => {
    console.log("on saving");
    e.preventDefault();
    var path = "";
    var obj = null;
    if (tab == "courts") {
      path = "/setup/court-setting/court";
      obj = { ...court };
    } else if (tab == "courttypes") {
      path = "/setup/court-setting/court-type";
      obj = { ...courtType, appModuleId: 1 };
    }

    setLoading(true);
    try {
      const url = `${Constants.apiUrl}${path}`;
      const resp = await fetch(url, {
        method: "POST",
        body: JSON.stringify(obj),
        headers: {
          "Content-Type": "application/json, text/plain",
          Authorization: `Bearer ${token}`,
        },
      });

      const data = await resp.json();
      setLoading(false);
      if (data.code == 0) {
        setAlert({
          open: true,
          title: "Court Setting",
          subtitle: "Settings saved successfully",
        });
        onDefault(data.id);
      } else if (data.code == -10) {
        setIsExpired(true);
      } else {
        setErr(data.status);
      }
      //   setFlow({pos:6,code:"congrat"})
    } catch (error) {
      setLoading(false);
      console.error(error);

      // onMove();
    }
  };

  const onDefault = (id) => {
    setErr("");
    setIsDialog(false);
    if (tab == "courts") {
      onLoadCourt();
      setCourt({ id: 0 });
    } else if (tab == "courttypes") {
      onLoadCourtType();
      setCourtType({ id: 0 });
    }
  };
  const onEdit = (obj, index) => {
    if (tab == "courts") {
      console.log(obj);
      setCourt(obj);
    } else if (tab == "courttypes") {
      setCourtType(obj);
    }
    setIsDialog(true);
  };

  const onLoadCourt = async () => {
    try {
      setLoading(true);
      const resp = await fetch(
        `${Constants.apiUrl}/setup/court-setting/courts`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );

      const data = await resp.json();
      setLoading(false);
      if (data.code == 0) {
        setCourts(data.list);
      } else if (data.code == -10) {
        setIsExpired(true);
      }
    } catch (error) {
      setLoading(false);
      console.error(error);
    }
  };
  const onLoadCourtType = async () => {
    try {
      setLoading(true);
      const resp = await fetch(
        `${Constants.apiUrl}/setup/court-setting/court-types`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );

      const data = await resp.json();
      setLoading(false);
      if (data.code == 0) {
        setCourtTypes(data.list);
      } else if (data.code == -10) {
        setIsExpired(true);
      }
    } catch (error) {
      setLoading(false);
      console.error(error);
    }
  };
  const onLoadJudgeTypes = async () => {
    //for account registration
    try {
      setLoading(true);
      const resp = await fetch(
        `${Constants.apiUrl}/setup/judge-setting/judge-types`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );

      const data = await resp.json();
      setLoading(false);
      setJudgeTypes(data.list);
    } catch (error) {
      setLoading(false);
      console.error(error);
    }
  };
  return (
    <div>
      <div className="tab_body">
        <div
          className="tab_section"
          style={{ display: "flex", gap: "20px", marginBottom: "20px" }}
        >
          <JisTabButton
            code="courts"
            isActive={tab == "courts"}
            title="Courts"
            data={page}
            isRoleBased={false}
            onClick={() => setTab("courts")}
          />
          <JisTabButton
            code="courttypes"
            isActive={tab == "courttypes"}
            title="Court Types"
            data={page}
            isRoleBased={false}
            onClick={() => setTab("courttypes")}
          />
          {/*   <JisTabButton code="room" isActive={tab=='room'}  title="Court Rooms" data={page} isRoleBased={false} onClick={()=> setTab('room')}/>
           */}
        </div>
        {tab == "courts" && (
          <div className="tab_view">
            <div style={{ textAlign: "right" }}>
              {" "}
              <JisButton variant="plain" onClick={onAdd}>
                Add Courts
              </JisButton>
            </div>
            <div className="table">
              <div class="section-cases">
                <span>Courts</span>
                <span className="total">{courts?.length}</span>
              </div>
              <table className="case-table">
                <thead>
                  <tr>
                    <th className="col-id">SN</th>
                    <th className="col-title">Name</th>
                    <th>Type</th>
                    <th className="col-medium">Division</th>
                    <th className="col-medium">Court Code</th>
                    <th className="col-title">Address</th>
                    <th>Phone</th>
                    <th>Room</th>
                    <th>Status</th>
                    <th className="col-action">Action</th>
                  </tr>
                </thead>
                <tbody>
                  {courts.map((g, i) => {
                    return (
                      <tr>
                        <td>{i + 1}</td>
                        <td>{g.name}</td>
                        <td>
                          {Constants.getItemById(judgeTypes, g.typeId)?.title}
                        </td>
                        <td>
                          {
                            Constants.getItemById(divisions, g.divisionId)
                              ?.title
                          }
                        </td>
                        <td>{g.courtCode}</td>
                        <td>{g.address1}</td>
                        <td>{g.phone1}</td>
                        <td>{g.lastRank}</td>
                       
                        <td style={{textAlign:'center'}}>{g.isActive?'Active':'Inactive'}<br></br> {g.activeStatus}</td>
                        <td>
                          <JisButton
                            variant="plain"
                            onClick={() => onEdit(g, i)}
                          >
                            Edit
                          </JisButton>
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
          </div>
        )}
        {tab == "courttypes" && (
          <div className="tab_view">
            <div style={{ textAlign: "right" }}>
              {" "}
              <JisButton variant="plain" onClick={onAdd}>
                Add Court Type
              </JisButton>
            </div>
            <div className="table">
              <div class="section-cases">
                <span>Court Types</span>
                <span className="total">{courtTypes?.length}</span>
              </div>
              <table className="case-table">
                <thead>
                  <tr>
                    <th className="col-id">SN</th>
                    <th className="col-title">Name</th>
                  </tr>
                </thead>
                <tbody>
                  {courtTypes.map((g, i) => {
                    return (
                      <tr>
                        <td>{i + 1}</td>
                        <td>{g.title}</td>
                        <td>
                          <JisButton onClick={() => onEdit(g, i)}>
                            Edit
                          </JisButton>
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
          </div>
        )}
        {tab == "room" && (
          <div className="tab_view">
            <div style={{ textAlign: "right" }}>
              {" "}
              <JisButton variant="plain" onClick={onAdd}>
                Add Room
              </JisButton>
            </div>
            <div className="table">
              <div class="section-cases">
                <span>Rooms</span>
                <span className="total">{rooms?.length}</span>
              </div>
              <table className="case-table">
                <thead>
                  <tr></tr>
                </thead>
                <tbody>
                  {rooms.map((g, i) => {
                    return <tr></tr>;
                  })}
                </tbody>
              </table>
            </div>
          </div>
        )}
      </div>
      <BackLoader open={loading} />
      {isDialog && tab == "courts" && (
        <JisDialogForm title="Court" onClose={onClose}>
          <div>
            <form onSubmit={onSave}>
              <div className="input-group">
                <label>
                  {" "}
                  Name <span className="required">*</span>
                </label>
                <div className="input-wrapper">
                  <DynamicIcon iname="phone_in_talk" />
                  <input
                    placeholder="Name"
                    name="name"
                    required={true}
                    value={court.name}
                    onChange={onCourtChange}
                  />
                </div>
              </div>
              <div className="select-group">
                <label>
                  {" "}
                  Judge Type <span className="required">*</span>
                </label>
                <select
                  name="typeId"
                  required={true}
                  value={court.typeId}
                  onChange={onCourtChange}
                >
                  <option value="">Select Judge Type</option>
                  {judgeTypes
                    ?.filter((e) => e.isActive)
                    .map((opt) => (
                      <option key={opt.id} value={opt.id}>
                        {opt.title}
                      </option>
                    ))}
                </select>
              </div>
              <div className="select-group">
                <label>
                  {" "}
                  Division <span className="required">*</span>
                </label>
                <select
                  name="divisionId"
                  required={true}
                  value={court.divisionId}
                  onChange={onCourtChange}
                >
                  <option value="">Select Division</option>
                  {divisions.map((opt) => (
                    <option key={opt.id} value={opt.id}>
                      {opt.title}
                    </option>
                  ))}
                </select>
              </div>
              <div className="input-group">
                <label>
                  {" "}
                  Court Code <span className="required">*</span>
                </label>
                <div className="input-wrapper">
                  <DynamicIcon iname="phone_in_talk" />
                  <input
                    placeholder="Court Code"
                    name="courtCode"
                    required={true}
                    value={court.courtCode}
                    onChange={onCourtChange}
                  />
                </div>
              </div>
              <div className="input-group">
                <label>
                  {" "}
                  Address <span className="required">*</span>
                </label>
                <div className="input-wrapper">
                  <DynamicIcon iname="phone_in_talk" />
                  <input
                    placeholder="Address"
                    name="address1"
                    required={true}
                    value={court.address1}
                    onChange={onCourtChange}
                  />
                </div>
              </div>
              <div className="input-group">
                <label>
                  Phone <span className="required">*</span>
                </label>
                <div className="input-wrapper">
                  <DynamicIcon iname="phone_in_talk" />
                  <input
                    placeholder="Phone Number"
                    name="phone1"
                    required={true}
                    value={court.phone1}
                    onChange={onCourtChange}
                  />
                </div>
              </div>
              <div className="input-group">
                <label>
                  Room <span className="required">*</span>
                </label>
                <div className="input-wrapper">
                  <DynamicIcon iname="chess-rook" />
                  <input
                    placeholder="Room"
                    name="lastRank"
                    type='number'
                    value={court.lastRank}
                    onChange={onCourtChange}
                  />
                </div>
              </div>

              <JisCheckbox
                value={court.isActive}
                label="Active"
                onChange={(e) => setCourt({ ...court, isActive: e })}
              />
             {!court.isActive && <div className="input-group">
                <label>
                  Reason for Inactive <span className="required">*</span>
                </label>
                <div className="input-wrapper">
                  <DynamicIcon iname="square-activity" />
                  <input
                    placeholder="Active Status"
                    name="activeStatus"
                    required={true}
                    value={court.activeStatus}
                    onChange={onCourtChange}
                  />
                </div>
              </div>} 
              <div>
                <JisButton type="submit">Save</JisButton>
              </div>
            </form>
          </div>
        </JisDialogForm>
      )}

      {isDialog && tab == "courttypes" && (
        <JisDialogForm title="Court Type" onClose={onClose}>
          <form onSubmit={onSave}>
            <div className="input-group">
              <label> Title</label>
              <div className="input-wrapper">
                <DynamicIcon iname="person_3" />
                <input
                  placeholder="Title"
                  name="title"
                  value={courtType.title}
                  onChange={onCourtTypeChange}
                  required={true}
                />
              </div>
            </div>
            <div className="input-group">
              <label> Room Prefix</label>
              <div className="input-wrapper">
                <DynamicIcon iname="person_3" />
                <input
                  placeholder="Room Prefix"
                  name="roomPrefix"
                  value={courtType.roomPrefix}
                  onChange={onCourtTypeChange}
                  required={true}
                />
              </div>
            </div>
            <JisCheckbox
              value={courtType.isActive}
              label="Active"
              onChange={(e) => setCourtType({ ...courtType, isActive: e })}
            />
            <div>
              <JisButton type="submit">
                {courtType.id == 0 ? "Save" : "Update"}{" "}
              </JisButton>
            </div>
          </form>
        </JisDialogForm>
      )}

      {isDialog && tab == "room" && (
        <JisDialogForm title="Room" onClose={onClose}>
          <form onSubmit={onSave}>
            <div className="input-group">
              <label> Title</label>
              <div className="input-wrapper">
                <DynamicIcon iname="person_3" />
                <input
                  placeholder="Title"
                  name="title"
                  value={courtType.title}
                  onChange={onCourtTypeChange}
                  required={true}
                />
              </div>
            </div>
            <div className="input-group">
              <label> Room Prefix</label>
              <div className="input-wrapper">
                <DynamicIcon iname="person_3" />
                <input
                  placeholder="Room Prefix"
                  name="roomPrefix"
                  value={courtType.roomPrefix}
                  onChange={onCourtTypeChange}
                  required={true}
                />
              </div>
            </div>
            <JisCheckbox
              value={courtType.isActive}
              label="Active"
              onChange={(e) => setCourtType({ ...courtType, isActive: e })}
            />
            <div>
              <JisButton type="submit">
                {courtType.id == 0 ? "Save" : "Update"}{" "}
              </JisButton>
            </div>
          </form>
        </JisDialogForm>
      )}
    </div>
  );
}

export default CourtSettings;
